import { render } from "./HeaderBar.vue?vue&type=template&id=65de0e70&ts=true"
import script from "./HeaderBar.vue?vue&type=script&lang=ts"
export * from "./HeaderBar.vue?vue&type=script&lang=ts"

import "./HeaderBar.vue?vue&type=style&index=0&id=65de0e70&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__